import type { MetricsResponse } from "@cdt/shared";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { fetchMetrics } from "@/lib/statsApi";

export function dashboardMetricsQueryKey(days: number) {
  return ["dashboard", "metrics", days] as const;
}

export function useDashboardMetrics(days: number) {
  return useQuery<MetricsResponse>({
    queryKey: dashboardMetricsQueryKey(days),
    queryFn: () => fetchMetrics(days),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  });
}
